import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";

import ProjectLanding from "modules/projects/views/Project-Listing";

const Projects = () => {
  return <ProjectLanding />;
};

Projects.getLayout = (page) => (
  <>
    <Head>
      <title>{config.SITE_NAME} | Your Projects</title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default Projects;
